import React, { useEffect } from 'react';
import Layout from './Layout/Layout';
import Home from './Pages/Home';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsConditions from './Pages/TermsConditions';
import About from './Pages/About';
import Build from './Pages/Build';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useLocation } from "react-router-dom";

import './App.scss';

function App() {

  const ScrollToAnchor = () => {
    const location = useLocation();

    useEffect(() => {
      if (location.hash) {
        setTimeout(() => {
          const element = document.querySelector(location.hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 400); // Delay to ensure DOM is rendered
      }
    }, [location]);

    return null;
  };

  return (
    <BrowserRouter>
      <ScrollToAnchor />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-conditions" element={<TermsConditions />} />
          <Route path="about" element={<About />} />
          <Route path="build" element={<Build />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
